exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-xero-account {\n  justify-content: center; }\n", ""]);

// exports
